const theme = {
  colors: {
    // Primary brand - klijentova paleta plave
    primary: "#708dab",
    primaryLight: "#a3b9cd",
    primaryDark: "#3b546d",

    // Navy - duboka morska
    navy: "#1a2332",
    navyLight: "#243044",

    // Neutrals
    white: "#ffffff",
    offWhite: "#f8f9fb",
    pearl: "#f0f3f6",
    lightGray: "#e2e8ee",
    midGray: "#8a9ab0",
    darkGray: "#4a5568",

    // Text
    textPrimary: "#1a2332",
    textSecondary: "#5a6a7e",
    textLight: "#8a9ab0",

    // Accent - gold za luxury feel (placeholder dok ne dobijemo finalnu paletu)
    gold: "#c9a96e",
    goldLight: "#dfc08a",

    // Status
    success: "#4caf82",
    error: "#e57373",
  },

  fonts: {
    // Serif za headings - premium osecaj kao u logou
    display: '"Cormorant Garamond", "Georgia", serif',
    // Sans-serif za body
    body: '"Inter", "Helvetica Neue", sans-serif',
    // Spaced caps za labele (kao "YACHTING" u logu)
    caps: '"Inter", "Helvetica Neue", sans-serif',
  },

  fontSizes: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    md: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    "2xl": "1.5rem", // 24px
    "3xl": "1.875rem", // 30px
    "4xl": "2.25rem", // 36px
    "5xl": "3rem", // 48px
    "6xl": "3.75rem", // 60px
    "7xl": "4.5rem", // 72px
  },

  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  lineHeights: {
    tight: 1.2,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
  },

  letterSpacings: {
    tight: "-0.02em",
    normal: "0",
    wide: "0.05em",
    wider: "0.1em",
    widest: "0.2em",
  },

  spacing: {
    xs: "0.25rem", // 4px
    sm: "0.5rem", // 8px
    md: "1rem", // 16px
    lg: "1.5rem", // 24px
    xl: "2rem", // 32px
    "2xl": "3rem", // 48px
    "3xl": "4rem", // 64px
    "4xl": "6rem", // 96px
    "5xl": "8rem", // 128px
  },

  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },

  borderRadius: {
    none: "0",
    sm: "2px",
    md: "4px",
    lg: "8px",
    xl: "12px",
    full: "9999px",
  },

  shadows: {
    sm: "0 1px 3px rgba(26, 35, 50, 0.08)",
    md: "0 4px 16px rgba(26, 35, 50, 0.10)",
    lg: "0 8px 32px rgba(26, 35, 50, 0.12)",
    xl: "0 16px 48px rgba(26, 35, 50, 0.15)",
  },

  transitions: {
    fast: "150ms ease",
    normal: "300ms ease",
    slow: "500ms ease",
    smooth: "600ms cubic-bezier(0.16, 1, 0.3, 1)",
  },

  zIndex: {
    base: 0,
    above: 1,
    dropdown: 100,
    sticky: 200,
    overlay: 300,
    modal: 400,
    toast: 500,
  },
};

export default theme;
